import React from 'react'

type NegotiationBannerProps = {
 visible?: boolean
 data?: string
}

const NegotiationBanner = ({
 visible,
 data,
}: NegotiationBannerProps) => {
 if (!visible) return null

 return (
  <div className='flex items-start gap-2 rounded-lg px-2 py-2 mb-2'>
   <i
    className='fa fa-info-circle text-[#0F487A] text-base shrink-0'
    aria-hidden='true'
   />
   <span className='text-[#0F487A] text-sm leading-5 mt-0.5'>
    {data}
   </span>
  </div>
 )
}

export default NegotiationBanner
